import { PodType } from "./components/MultistopPodTypeField";

export type MultistopPodFinalizingStop = {
  stop_id: number;
  stop_number: number;
};

export type IsMultistopPodFinalizingInput = {
  podType: PodType;
  selectedStopId: number | null;
  stops: MultistopPodFinalizingStop[];
  markShipmentAsDone: boolean;
};

function getLastDeliveryStopId(stops: MultistopPodFinalizingStop[]): number | null {
  if (stops.length === 0) {
    return null;
  }

  const [firstStop, ...remainingStops] = stops;
  return remainingStops.reduce(
    (lastStop, stop) => (stop.stop_number > lastStop.stop_number ? stop : lastStop),
    firstStop,
  ).stop_id;
}

export function isMultistopPodFinalizing({
  podType,
  selectedStopId,
  stops,
  markShipmentAsDone,
}: IsMultistopPodFinalizingInput): boolean {
  if (podType === "master") {
    return true;
  }

  if (markShipmentAsDone) {
    return true;
  }

  if (selectedStopId == null) {
    return false;
  }

  return selectedStopId === getLastDeliveryStopId(stops);
}
